export const state = {
  typeToLayer: {
    0: 'PlanetScope',
    1: 'PlanetVars',
    2: 'PlanetSkySat'
  },
  layers: [],
  dates: [],
  selectedRange: [],
  orgLayers: {},
  selectedFeature: {
    feature: null,
    coordinates: null,
    isVisible: false
  }
}
